<template>
  <div class="come">
    <div class="page-wit">
      <div class="title">
        <h2>
          <span class="tit-l">
            <img src="@/assets/images/partner/tit-l.png" width="34" /> </span
          >快来成为城市代理商
          <span class="tit-r">
            <img src="@/assets/images/partner/tit-r.png" width="35" />
          </span>
        </h2>
      </div>
      <div class="ask">
        <h2>基本要求&开放区域</h2>
        <ul>
          <li>
            <span>
              <img src="@/assets/images/partner/lis-bg.png" width="6" /> </span
            >具有正规公司资质；流动资金不低于50W；农产品蔬果肉禽等食材经营者或者从业者；有核心团队成员；年龄在40岁以下。
          </li>
          <li>
            <span>
              <img src="@/assets/images/partner/lis-bg.png" width="6" /> </span
            >当地资源：具有本地餐饮商户资源，具有农产品蔬果肉禽等食材进货渠道资源。
          </li>
          <li>
            <span>
              <img src="@/assets/images/partner/lis-bg.png" width="6" /> </span
            >创业者精神：具有吃苦耐劳精神，长期经营者初心。
          </li>

          <li>
            <span>
              <img src="@/assets/images/partner/lis-bg.png" width="6" /> </span
            >首批招募地区:
          </li>
          <li style="margin-top: 50px; width: 1000px">
            <!-- <span></span>
            江西：萍乡市。
            <br />湖南：湘潭市-韶山市、岳阳市-汨罗市、岳阳市-华容县、益阳市-南县、湘潭市-湘乡市、岳阳市-平江县。
            <br />湖北：咸宁市-赤壁市、咸宁市-崇阳县、咸宁市-通山县、咸宁市-嘉鱼县、荆州市-洪湖市、黄石市-阳新县、孝感市-应城市、孝感市-安陆市、孝感市-云梦县、孝感市-孝昌县、孝感市-大悟县、黄冈市-罗田县、黄冈市-红安县。 -->
            <table border="1" class="gridtable">
              <thead></thead>
              <tbody>
                <tr>
                  <td>序号</td>
                  <td>省份</td>
                  <td>地级市</td>

                  <td>序号</td>
                  <td>省份</td>
                  <td>地级市</td>

                  <td>序号</td>
                  <td>省份</td>
                  <td>地级市</td>

                  <td>序号</td>
                  <td>省份</td>
                  <td>地级市</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>黑龙江省</td>
                  <td>大庆市</td>

                  <td>41</td>
                  <td>陕西省</td>
                  <td>商洛市</td>

                  <td>81</td>
                  <td>西藏自治区</td>
                  <td>那曲地区</td>

                  <td>121</td>
                  <td>广西壮族自治区</td>
                  <td>玉林市</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>黑龙江省</td>
                  <td>齐齐哈尔市</td>

                  <td>42</td>
                  <td>陕西省</td>
                  <td>铜川市</td>

                  <td>82</td>
                  <td>西藏自治区</td>
                  <td>日喀则地区</td>

                  <td>122</td>
                  <td>福建省</td>
                  <td>南平市</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>黑龙江省</td>
                  <td>大兴安岭地区</td>

                  <td>43</td>
                  <td>陕西省</td>
                  <td>延安市</td>

                  <td>83</td>
                  <td>西藏自治区</td>
                  <td>山南地区</td>

                  <td>123</td>
                  <td>福建省</td>
                  <td>龙岩市</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>黑龙江省</td>
                  <td>鹤岗市</td>

                  <td>44</td>
                  <td>宁夏回族自治区</td>
                  <td>固原市</td>

                  <td>84</td>
                  <td>贵州省</td>
                  <td>毕节市</td>

                  <td>124</td>
                  <td>广东省</td>
                  <td>潮州市</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>黑龙江省</td>
                  <td>黑河市</td>

                  <td>45</td>
                  <td>宁夏回族自治区</td>
                  <td>石嘴山市</td>

                  <td>85</td>
                  <td>贵州省</td>
                  <td>六盘水市</td>

                  <td>125</td>
                  <td>广东省</td>
                  <td>揭阳市</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>黑龙江省</td>
                  <td>鸡西市</td>

                  <td>46</td>
                  <td>宁夏回族自治区</td>
                  <td>吴忠市</td>

                  <td>86</td>
                  <td>贵州省</td>
                  <td>黔东南苗族侗族自治州</td>

                  <td>126</td>
                  <td>广东省</td>
                  <td>汕头市</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>黑龙江省</td>
                  <td>佳木斯市</td>

                  <td>47</td>
                  <td>宁夏回族自治区</td>
                  <td>银川市</td>

                  <td>87</td>
                  <td>贵州省</td>
                  <td>黔西南布依族苗族自治州</td>

                  <td>127</td>
                  <td>广东省</td>
                  <td>韶关市</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>黑龙江省</td>
                  <td>牡丹江市</td>

                  <td>48</td>
                  <td>宁夏回族自治区</td>
                  <td>中卫市</td>

                  <td>88</td>
                  <td>贵州省</td>
                  <td>铜仁市</td>

                  <td>128</td>
                  <td>广东省</td>
                  <td>阳江市</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>黑龙江省</td>
                  <td>七台河市</td>

                  <td>49</td>
                  <td>甘肃省</td>
                  <td>白银市</td>

                  <td>89</td>
                  <td>四川省</td>
                  <td>阿坝藏族羌族自治州</td>

                  <td>129</td>
                  <td>广东省</td>
                  <td>云浮市</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>黑龙江省</td>
                  <td>双鸭山市</td>

                  <td>50</td>
                  <td>甘肃省</td>
                  <td>平凉市</td>

                  <td>90</td>
                  <td>四川省</td>
                  <td>巴中市</td>

                  <td>130</td>
                  <td>江西省</td>
                  <td>抚州市</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>黑龙江省</td>
                  <td>绥化市</td>

                  <td>51</td>
                  <td>甘肃省</td>
                  <td>庆阳市</td>

                  <td>91</td>
                  <td>四川省</td>
                  <td>甘孜藏族自治州</td>

                  <td>131</td>
                  <td>江西省</td>
                  <td>吉安市</td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>黑龙江省</td>
                  <td>伊春市</td>

                  <td>52</td>
                  <td>甘肃省</td>
                  <td>定西市</td>

                  <td>92</td>
                  <td>四川省</td>
                  <td>凉山彝族自治州</td>

                  <td>132</td>
                  <td>江西省</td>
                  <td>上饶市</td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>吉林省</td>
                  <td>白山市</td>

                  <td>53</td>
                  <td>甘肃省</td>
                  <td>甘南州</td>

                  <td>93</td>
                  <td>四川省</td>
                  <td>攀枝花市</td>

                  <td>133</td>
                  <td>江西省</td>
                  <td>新余市</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>吉林省</td>
                  <td>松原市</td>

                  <td>54</td>
                  <td>甘肃省</td>
                  <td>嘉峪关市</td>

                  <td>94</td>
                  <td>四川省</td>
                  <td>雅安市</td>

                  <td>134</td>
                  <td>江西省</td>
                  <td>景德镇市</td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>吉林省</td>
                  <td>通化市</td>

                  <td>55</td>
                  <td>甘肃省</td>
                  <td>金昌市</td>

                  <td>95</td>
                  <td>四川省</td>
                  <td>资阳市</td>

                  <td>135</td>
                  <td>江西省</td>
                  <td>宜春市</td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>吉林省</td>
                  <td>辽源市</td>

                  <td>56</td>
                  <td>甘肃省</td>
                  <td>酒泉市</td>

                  <td>96</td>
                  <td>云南省</td>
                  <td>楚雄彝族自治州</td>

                  <td>136</td>
                  <td>江西省</td>
                  <td>鹰潭市</td>
                </tr>
                <tr>
                  <td>17</td>
                  <td>吉林省</td>
                  <td>四平市</td>

                  <td>57</td>
                  <td>甘肃省</td>
                  <td>临夏州</td>

                  <td>97</td>
                  <td>云南省</td>
                  <td>大理白族自治州</td>

                  <td>137</td>
                  <td>湖南省</td>
                  <td>怀化市</td>
                </tr>
                <tr>
                  <td>18</td>
                  <td>吉林省</td>
                  <td>延边朝鲜族自治州</td>

                  <td>58</td>
                  <td>甘肃省</td>
                  <td>陇南市</td>

                  <td>98</td>
                  <td>云南省</td>
                  <td>迪庆藏族自治州</td>

                  <td>138</td>
                  <td>湖南省</td>
                  <td>邵阳市</td>
                </tr>
                <tr>
                  <td>19</td>
                  <td>辽宁省</td>
                  <td>朝阳市</td>

                  <td>59</td>
                  <td>甘肃省</td>
                  <td>天水市</td>

                  <td>99</td>
                  <td>云南省</td>
                  <td>红河哈尼族彝族自治州</td>

                  <td>139</td>
                  <td>湖南省</td>
                  <td>张家界市</td>
                </tr>
                <tr>
                  <td>20</td>
                  <td>辽宁省</td>
                  <td>鞍山市</td>

                  <td>60</td>
                  <td>甘肃省</td>
                  <td>武威市</td>

                  <td>100</td>
                  <td>云南省</td>
                  <td>丽江市</td>

                  <td>140</td>
                  <td>湖北省</td>
                  <td>天门</td>
                </tr>
                <tr>
                  <td>21</td>
                  <td>辽宁省</td>
                  <td>盘锦市</td>

                  <td>61</td>
                  <td>甘肃省</td>
                  <td>张掖市</td>

                  <td>101</td>
                  <td>云南省</td>
                  <td>临沧市</td>

                  <td>141</td>
                  <td>湖北省</td>
                  <td>随州市</td>
                </tr>
                <tr>
                  <td>22</td>
                  <td>辽宁省</td>
                  <td>营口市</td>

                  <td>62</td>
                  <td>青海省</td>
                  <td>果洛藏族自治州</td>

                  <td>102</td>
                  <td>云南省</td>
                  <td>怒江傈僳族自治州</td>

                  <td>142</td>
                  <td>湖北省</td>
                  <td>襄樊市</td>
                </tr>
                <tr>
                  <td>23</td>
                  <td>辽宁省</td>
                  <td>阜新市</td>

                  <td>63</td>
                  <td>青海省</td>
                  <td>海北藏族自治州</td>

                  <td>103</td>
                  <td>云南省</td>
                  <td>普洱市</td>

                  <td>143</td>
                  <td>安徽省</td>
                  <td>安庆市</td>
                </tr>
                <tr>
                  <td>24</td>
                  <td>内蒙古自治区</td>
                  <td>阿拉善盟</td>

                  <td>64</td>
                  <td>青海省</td>
                  <td>海南藏族自治州</td>

                  <td>104</td>
                  <td>云南省</td>
                  <td>曲靖市</td>

                  <td>144</td>
                  <td>安徽省</td>
                  <td>毫州市</td>
                </tr>
                <tr>
                  <td>25</td>
                  <td>内蒙古自治区</td>
                  <td>赤峰市</td>

                  <td>65</td>
                  <td>青海省</td>
                  <td>海西蒙古族藏族自治州</td>

                  <td>105</td>
                  <td>云南省</td>
                  <td>文山壮族苗族自治州</td>

                  <td>145</td>
                  <td>安徽省</td>
                  <td>黄山市</td>
                </tr>
                <tr>
                  <td>26</td>
                  <td>内蒙古自治区</td>
                  <td>兴安盟</td>

                  <td>66</td>
                  <td>青海省</td>
                  <td>黄南藏族自治州</td>

                  <td>106</td>
                  <td>云南省</td>
                  <td>西双版纳傣族自治州</td>

                  <td>146</td>
                  <td>安徽省</td>
                  <td>宿州市</td>
                </tr>
                <tr>
                  <td>27</td>
                  <td>内蒙古自治区</td>
                  <td>呼伦贝尔市</td>

                  <td>67</td>
                  <td>青海省</td>
                  <td>玉树藏族自治州</td>

                  <td>107</td>
                  <td>云南省</td>
                  <td>玉溪市</td>

                  <td>147</td>
                  <td>山东省</td>
                  <td>菏泽市</td>
                </tr>
                <tr>
                  <td>28</td>
                  <td>内蒙古自治区</td>
                  <td>乌海市</td>

                  <td>68</td>
                  <td>新疆维吾尔自治区</td>
                  <td>阿克苏地区</td>

                  <td>108</td>
                  <td>云南省</td>
                  <td>昭通市</td>

                  <td>148</td>
                  <td>山东省</td>
                  <td>济宁市</td>
                </tr>
                <tr>
                  <td>29</td>
                  <td>内蒙古自治区</td>
                  <td>乌兰察布市</td>

                  <td>69</td>
                  <td>新疆维吾尔自治区</td>
                  <td>阿勒泰地区</td>

                  <td>109</td>
                  <td>广西壮族自治区</td>
                  <td>百色市</td>

                  <td>149</td>
                  <td>山东省</td>
                  <td>聊城市</td>
                </tr>
                <tr>
                  <td>30</td>
                  <td>河北省</td>
                  <td>唐山市</td>

                  <td>70</td>
                  <td>新疆维吾尔自治区</td>
                  <td>昌吉回族自治州</td>

                  <td>110</td>
                  <td>广西壮族自治区</td>
                  <td>北海市</td>

                  <td>150</td>
                  <td>山东省</td>
                  <td>枣庄市</td>
                </tr>
                <tr>
                  <td>31</td>
                  <td>河北省</td>
                  <td>承德市</td>

                  <td>71</td>
                  <td>新疆维吾尔自治区</td>
                  <td>哈密地区</td>

                  <td>111</td>
                  <td>广西壮族自治区</td>
                  <td>崇左市</td>

                  <td>151</td>
                  <td>河南省</td>
                  <td>安阳市</td>
                </tr>
                <tr>
                  <td>32</td>
                  <td>河北省</td>
                  <td>邯郸市</td>

                  <td>72</td>
                  <td>新疆维吾尔自治区</td>
                  <td>和田地区</td>

                  <td>112</td>
                  <td>广西壮族自治区</td>
                  <td>防城港市</td>

                  <td>152</td>
                  <td>河南省</td>
                  <td>鹤壁市</td>
                </tr>
                <tr>
                  <td>33</td>
                  <td>河北省</td>
                  <td>张家口市</td>

                  <td>73</td>
                  <td>新疆维吾尔自治区</td>
                  <td>喀什地区</td>

                  <td>113</td>
                  <td>广西壮族自治区</td>
                  <td>贵港市</td>

                  <td>153</td>
                  <td>河南省</td>
                  <td>洛阳市</td>
                </tr>
                <tr>
                  <td>34</td>
                  <td>山西省</td>
                  <td>吕梁市</td>

                  <td>74</td>
                  <td>新疆维吾尔自治区</td>
                  <td>克拉玛依市</td>

                  <td>114</td>
                  <td>广西壮族自治区</td>
                  <td>桂林市</td>

                  <td>154</td>
                  <td>河南省</td>
                  <td>漯河市</td>
                </tr>
                <tr>
                  <td>35</td>
                  <td>山西省</td>
                  <td>阳泉市</td>

                  <td>75</td>
                  <td>新疆维吾尔自治区</td>
                  <td>克孜勒苏柯尔克孜自治州</td>

                  <td>115</td>
                  <td>广西壮族自治区</td>
                  <td>河池市</td>

                  <td>155</td>
                  <td>河南省</td>
                  <td>平顶山市</td>
                </tr>
                <tr>
                  <td>36</td>
                  <td>山西省</td>
                  <td>临汾市</td>

                  <td>76</td>
                  <td>新疆维吾尔自治区</td>
                  <td>塔城地区</td>

                  <td>116</td>
                  <td>广西壮族自治区</td>
                  <td>贺州市</td>

                  <td>156</td>
                  <td>河南省</td>
                  <td>濮阳市</td>
                </tr>
                <tr>
                  <td>37</td>
                  <td>山西省</td>
                  <td>忻州市</td>

                  <td>77</td>
                  <td>新疆维吾尔自治区</td>
                  <td>吐鲁番地区</td>

                  <td>117</td>
                  <td>广西壮族自治区</td>
                  <td>来宾市</td>

                  <td>157</td>
                  <td>河南省</td>
                  <td>三门峡市</td>
                </tr>
                <tr>
                  <td>38</td>
                  <td>陕西省</td>
                  <td>安康市</td>

                  <td>78</td>
                  <td>新疆维吾尔自治区</td>
                  <td>伊犁哈萨克自治州</td>

                  <td>118</td>
                  <td>广西壮族自治区</td>
                  <td>柳州市</td>

                  <td>158</td>
                  <td>河南省</td>
                  <td>商丘市</td>
                </tr>
                <tr>
                  <td>39</td>
                  <td>陕西省</td>
                  <td>宝鸡市</td>

                  <td>79</td>
                  <td>西藏自治区</td>
                  <td>昌都地区</td>

                  <td>119</td>
                  <td>广西壮族自治区</td>
                  <td>钦州市</td>

                  <td>159</td>
                  <td>河南省</td>
                  <td>周口市</td>
                </tr>
                <tr>
                  <td>40</td>
                  <td>陕西省</td>
                  <td>汉中市</td>

                  <td>80</td>
                  <td>西藏自治区</td>
                  <td>林芝地区</td>

                  <td>120</td>
                  <td>广西壮族自治区</td>
                  <td>梧州市</td>

                  <td>160</td>
                  <td>河南省</td>
                  <td>驻马店市</td>
                </tr>
              </tbody>
            </table>
          </li>
          <li>
            <span style="color: #000; padding-top: 3px"
              >注：全国其它地区同步招募中。</span
            >
          </li>
        </ul>
      </div>
      <div class="contact-code">
        <h2>联系方式</h2>
        <ul>
          <li>
            <span>
              <img
                src="@/assets/images/partner/emails-bg.png"
                width="22"
              /> </span
            >邮箱：gaojie01@meicai.cn
          </li>
          <li>
            <span>
              <img src="@/assets/images/partner/tels-bg.png" width="22" />
            </span>
            电话：{{ $concatPhone || "4006-135-135" }}
          </li>
        </ul>
        <dl>
          <dt>
            <img src="@/assets/images/partner/mas.png" width="120" />
          </dt>
          <dd class="rush">
            <div class="signUp" @click="handleClick">我要报名</div>
          </dd>
          <dd class="info">扫二维码关注美菜</dd>
        </dl>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "come",
  data() {
    return {
      dialogVisbility: false,
    };
  },
  methods: {
    handleClick() {
      this.$emit("change", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.come {
  padding: 80px 0 100px;
  background: #fafafa;
  .title {
    height: 100px;
    h2 {
      font-size: 34px;
      position: relative;
      width: 400px;
      margin: 0 auto;
      text-align: center;
    }
  }
  .ask {
    width: 660px;
    float: left;
    h2 {
      font-size: 24px;
      height: 48px;
    }
    ul li {
      padding: 9px 0 9px 32px;
      font-size: 15px;
      color: #757575;
      position: relative;
      span {
        position: absolute;
        left: 3px;
        top: 6px;
      }
    }
  }
  .contact-code {
    float: right;
    width: 280px;
    h2 {
      font-size: 24px;
      height: 40px;
    }
    ul li {
      padding: 9px 0 9px 40px;
      font-size: 15px;
      color: #757575;
      position: relative;
      span {
        position: absolute;
        left: 2px;
        top: 10px;
      }
    }
    dl {
      height: 120px;
      margin-top: 15px;
      dt {
        float: left;
        width: 120px;
      }
      dd {
        float: left;
        padding-left: 8px;
      }
      dd.rush {
        margin-top: 25px;
        .signUp {
          width: 140px;
          height: 40px;
          display: block;
          background: #f76064;
          color: #fff;
          border-radius: 70px;
          text-align: center;
          line-height: 40px;
          font-size: 18px;
          text-decoration: none;
          box-shadow: 0 0px 10px rgba(0, 0, 0, 0.14);
          &:hover {
            background: #e84d51;
            text-decoration: none;
          }
        }
      }
      dd.info {
        text-align: center;
        color: #757575;
        margin-top: 10px;
        width: 140px;
        font-size: 13px;
      }
    }
  }
}

table.gridtable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #666666;
  background-color: #dedede;
}
table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #666666;
  background-color: #ffffff;
}
</style>
